import { GET_DASHBOARD_DATA_REQUEST } from '../../constants/redux';

export const getDashboardStatistics = () => {
  return {
    type: GET_DASHBOARD_DATA_REQUEST
  };
};
